var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.645 11.782v.436c0 .24-.196.435-.435.435h-3.557v3.557c0 .24-.196.435-.435.435h-.436a.437.437 0 0 1-.435-.435v-3.557H7.79a.437.437 0 0 1-.435-.435v-.436c0-.24.196-.435.435-.435h3.557V7.79c0-.24.196-.435.435-.435h.436c.24 0 .435.196.435.435v3.557h3.557c.24 0 .435.196.435.435zM21 12c0 4.972-4.028 9-9 9s-9-4.028-9-9 4.028-9 9-9 9 4.028 9 9zm-1.161 0c0-4.351-3.531-7.839-7.839-7.839-4.351 0-7.839 3.531-7.839 7.839 0 4.351 3.531 7.839 7.839 7.839 4.351 0 7.839-3.531 7.839-7.839z",
    fill: "currentColor"
  })));
};

export default SvgPlusCircle;